import { Component, Input } from '@angular/core';
import { Garage } from '@shared/models';
import { AmplitudeEventService, CoreDataService, FeatureFlagService } from '@core/services';
import { ContractCreateOpened } from '@integrations/amplitude';

@Component({
  selector: 'app-garage-details',
  templateUrl: './garage-details.component.html',
  styleUrl: './garage-details.component.scss',
})
export class GarageDetailsComponent {
  @Input() garage?: Garage;
  @Input() allowContractCreation: boolean = true;

  showWiparkShortTermParking: boolean = this.featureFlagService.getFeatureFlag('translation_key') === 'wipark';

  constructor(
    private featureFlagService: FeatureFlagService,
    private amplitudeEventService: AmplitudeEventService,
    private coreDataService: CoreDataService,
  ) {}

  get creatingContractEnabled(): boolean {
    return (
      this.featureFlagService.getFeatureFlag('enable_contract_creation_products') &&
      this.allowContractCreation &&
      (
        this.coreDataService.coreData.value.signup_status.has_payment_method || this.coreDataService.isPaymentMethodOptional()
      )
    );
  }

  get bookableContractTemplates() {
    return this.garage?.contract_templates?.filter((template) => template.bookable === 'public' && template.approval_required !== true) || [];
  }

  get contractRequestTemplates() {
    return this.garage?.contract_templates?.filter((template) => template.bookable === 'public' && template.approval_required === true) || [];
  }

  get informationContractTemplates() {
    return this.garage?.contract_templates?.filter((template) => template.bookable === 'information') || [];
  }

  get noContractsAvailable() {
    return this.bookableContractTemplates.length === 0 && this.informationContractTemplates.length === 0 && this.contractRequestTemplates.length === 0;
  }

  formatAddress(garage: Garage): string {
    return `${garage.street} ${garage.number}, ${garage.zip_code} ${garage.city}`;
  }

  sendAddContractEventToAmplitude(): void {
    if (!this.creatingContractEnabled) {
      return;
    }
    this.amplitudeEventService.trackEvent(
      new ContractCreateOpened({
        referredByPage: 'products',
        contractType: 'contract',
      }),
    );
  }

  sendAddContractRequestEventToAmplitude(): void {
    if (!this.creatingContractEnabled) {
      return;
    }
    this.amplitudeEventService.trackEvent(
      new ContractCreateOpened({
        referredByPage: 'products',
        contractType: 'request',
      }),
    );
  }
}
